
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ru/contact",
      function () {
        return require("private-next-pages/ru/contact.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ru/contact"])
      });
    }
  